import { init as initFb } from './fb'

export const init = () => {
  initFb()
}
